import React from 'react'

import { AddDocumentsForm } from 'presentation/patient/components/Forms/AddDocuments'

export default function AddDocumentsLayout() {
  return <AddDocumentsForm />
}
